import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { DetailsLocationQuery } from 'src/sell/lib/details/interfaces/detail-location.query';
import { DetailsQueries } from 'src/sell/lib/details/queries/details.queries';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-auto-vision-seller-location',
    templateUrl: './auto-vision-seller-location.component.html',
    styleUrls: ['./auto-vision-seller-location.component.scss'],
    imports: [AsyncPipe]
})
export class AutoVisionSellerLocationComponent extends SaComponent implements OnInit {
  @Select(DetailsQueries.location) location$: Observable<DetailsLocationQuery>;
  @Input() showHeading = true;

  autoVisionSellerLocation = {
    sellerAndLocation: '',
    ariaLabelSellerName: '',
    vehicleLocation: '',
    notAvailable: '',
  };

  constructor(private readonly translocoService: TranslocoService) {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  isLocationAvailable(location) {
    return !location.name && !location.addressLine1 && !location.city && !location.state && !location.zip;
  }

  isSellerLocationAvailable(location) {
    return !location.sellerName || location.sellerName === '';
  }

  getTranslations(): void {
    const keyParams = {
      'sellModule.details.sellerLocation': {},
      'common': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translate => {
        this.autoVisionSellerLocation.sellerAndLocation = translate[0].sellerAndLocation;
        this.autoVisionSellerLocation.ariaLabelSellerName = translate[0].ariaLabelSellerName;
        this.autoVisionSellerLocation.vehicleLocation = translate[0].vehicleLocation;
        this.autoVisionSellerLocation.notAvailable = translate[1].notAvailable;
      });
  }
}
